exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Shared transition-modal styles live in src/styles.css (.transition-* classes). */\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/custom-modals/signup-notice-modal.component.css
// module id = ../../../../../src/app/custom-modals/signup-notice-modal.component.css
// module chunks = main